import { createSlice } from "@reduxjs/toolkit";

import { LOCAL_STORAGE_KEYS } from "../../../Util/constants";

const initialState = {
  puzzleType: null,
  puzzle: null,
  puzzleId: null,
  leaderboard: null,
};
export const publicPuzzleSlice = createSlice({
  name: LOCAL_STORAGE_KEYS.PUZZLE,
  initialState,
  reducers: {
    setLeaderboard: (state, action) => {
      state.leaderboard = action.payload;
    },
    setPuzzleType: (state, action) => {
      state.puzzleType = action.payload;
    },
    setPublicPuzzleAndPuzzleType: (state, action) => {
      const { puzzleId, puzzle, puzzleType } = action.payload;
      // console.log(puzzle)
      state.puzzle = {...puzzle};
      state.puzzleType = puzzleType;
      state.puzzleId = puzzleId;
    },

    // Timer - Modularaize
    incrementTimer: (state) => {
      const time = state.puzzle.timer.time;
      // console.log(time);
      state.puzzle.timer = {
        ...state.puzzle.timer,
        time: time + 1,
      };
    },
    startTimer: (state) => {
      if (state.puzzle?.timer) {
        state.puzzle.timer = {
          ...state.puzzle.timer,
          timer_active: true,
        };
      }
    },
    stopTimer: (state) => {
      // state.timer[state.selectedNewsie] = {
      //   ...state.timer[state.selectedNewsie],
      //   timer_active: true,
      // };
    },

    // Wordsearch
    findWordsearchWord: (state, action) => {
      state.puzzle.words = action.payload;
    },

    // Newsie
    selectNewsieCard: (state, action) => {
      state.puzzle.incorrectGuess = false;
      const payload = action.payload;
      const newSelectedWords = [...state.puzzle.selectedWords];
      newSelectedWords[payload.columnIndex] = payload.wordIndex;
      state.puzzle.selectedWords = newSelectedWords;
      if (newSelectedWords.every((i) => Number.isInteger(i))) {
        state.puzzle.guessable = true;
      } else {
        state.puzzle.guessable = false;
      }
    },
    declareVictory: (state) => {
      state.puzzle = { ...state.puzzle, winner: true };
    },
    guessStory: (state, action) => {
      const selectedWords = state.puzzle.selectedWords;
      const guess = [];
      state.puzzle.newsieGrid.forEach((col, i) => {
        guess.push(col[selectedWords[i]]);
      });
      let solvedIndex = null;
      for (let i = 0; i < state.puzzle.newsieInput.length; i++) {
        if (state.puzzle.newsieInput[i].join() === guess.join()) {
          solvedIndex = i;
          break;
        }
      }
      // Correct Guess
      if (Number.isInteger(solvedIndex)) {
        state.puzzle.correctGuess = true;
        state.puzzle.solvedIndex = solvedIndex;
      } else {
        // Incorrect Guess
        state.puzzle.incorrectGuesses = state.puzzle.incorrectGuesses + 1;
        state.puzzle.correctGuess = false;
      }
    },
    clearGuess: (state) => {
      state.puzzle.correctGuess = undefined;
    },
    addStoryToSolvedStories: (state) => {
      state.puzzle.correctGuess = undefined;
      const selectedWords = state.puzzle.selectedWords;
      const point = state.puzzle.takeawayPoints[state.puzzle.solvedIndex];
      const correctWords = selectedWords.map((correctWordIndex, i) => {
        return state.puzzle.newsieGrid[i].splice(correctWordIndex, 1);
      });
      state.puzzle.solvedStories = [
        ...state.puzzle.solvedStories,
        { point, correctWords },
      ];
      state.puzzle.selectedWords = state.puzzle.selectedWords.map((x) => null);
      state.puzzle.solvedIndex = undefined;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setLeaderboard,
  setPuzzleType,
  setPublicPuzzleAndPuzzleType,
  incrementTimer,
  startTimer,
  stopTimer,
  selectNewsieCard,
  guessStory,
  clearGuess,
  addStoryToSolvedStories,
  findWordsearchWord,
  declareVictory
} = publicPuzzleSlice.actions;

export default publicPuzzleSlice.reducer;
